{
  "id": "775949d8-adb3-4e29-a360-b0464ee7d869",
  "competitionUnitId": "5dd77e79-80eb-0d1a-567a-42912a3989f8",
  "marketDate": "2026-10-01",
  "closes_at": "2026-10-25T22:00:00Z",
  "generatedAt": "2026-09-30T23:34:52.104933Z",
  "players": [
    {
      "playerInstanceId": "a8a5dded-a303-4b5c-86b9-bd8c2e16b689",
      "playerDefinitionId": "93994b59-5e46-581f-841b-10ee34bdb695",
      "displayName": "Jesús Vázquez",
      "position": "DEFENDER",
      "type": "REAL",
      "marketValue": 5000000.00,
      "expectedVersion": 0,
      "averagePoints": 5.2,
      "last3AveragePoints": 6.0,
      "realClub": {
        "id": "947374aa-0dca-57ab-9149-32a0246426d8",
        "name": "Valencia CF",
        "shortName": "VAL"
      }
    },
    {
      "playerInstanceId": "ed9a3d04-df8c-4bde-bd59-0c6ae7b8baff",
      "playerDefinitionId": "029d0d2e-6b93-51d2-ae33-d4087fe2b3b7",
      "displayName": "Carlos Dotor",
      "position": "MIDFIELDER",
      "type": "REAL",
      "marketValue": 5000000.00,
      "expectedVersion": 0,
      "averagePoints": 4.8,
      "last3AveragePoints": 5.3,
      "realClub": {
        "id": "0911c8a4-98cc-5b9e-b978-9fbe96201a87",
        "name": "Málaga CF",
        "shortName": "MGA"
      }
    },
    {
      "playerInstanceId": "613b4775-73e3-42a3-946e-165b428ae451",
      "playerDefinitionId": "160b7fcc-64b4-5008-9e3f-6f5e2263c412",
      "displayName": "Marc Casadó",
      "position": "MIDFIELDER",
      "type": "REAL",
      "marketValue": 5000000.00,
      "expectedVersion": 0,
      "averagePoints": 6.7,
      "last3AveragePoints": 7.4,
      "realClub": {
        "id": "e82a5fde-22b1-5036-8763-5cdb76d60fab",
        "name": "FC Barcelona",
        "shortName": "BAR"
      }
    },
    {
      "playerInstanceId": "e1995bf2-95cd-4d82-a3db-e45ec73306ba",
      "playerDefinitionId": "38122c20-f220-5e30-b0df-a2b07e93818e",
      "displayName": "David Affengruber",
      "position": "DEFENDER",
      "type": "REAL",
      "marketValue": 5000000.00,
      "expectedVersion": 0,
      "averagePoints": 5.0,
      "last3AveragePoints": 4.7,
      "realClub": {
        "id": "7f3a2878-f783-5113-80fc-96795e5010ad",
        "name": "Elche CF",
        "shortName": "ELC"
      }
    },
    {
      "playerInstanceId": "61af893c-9d26-4b65-adc9-d4798528ca50",
      "playerDefinitionId": "b1999def-70d3-51f7-803a-1383064be71c",
      "displayName": "Thiago Fernández",
      "position": "FORWARD",
      "type": "REAL",
      "marketValue": 5000000.00,
      "expectedVersion": 0,
      "averagePoints": 5.9,
      "last3AveragePoints": 6.8,
      "realClub": {
        "id": "2e19e51c-0016-55cc-a523-8d01228f8ee5",
        "name": "Levante UD",
        "shortName": "LEV"
      }
    },
    {
      "playerInstanceId": "eedaae3c-f302-4f12-ac36-cbb5b489bf06",
      "playerDefinitionId": "834d3b83-f4d4-5577-83af-11f06ffa15dd",
      "displayName": "Mario Martín",
      "position": "MIDFIELDER",
      "type": "REAL",
      "marketValue": 5000000.00,
      "expectedVersion": 0,
      "averagePoints": 4.5,
      "last3AveragePoints": 4.0,
      "realClub": {
        "id": "c65ec3a9-ad5a-5f16-ab71-71f4a98ed6d5",
        "name": "Getafe CF",
        "shortName": "GET"
      }
    },
    {
      "playerInstanceId": "fb46afad-3dd4-4755-8b24-83ada2385485",
      "playerDefinitionId": "042a026c-4615-5af3-be67-953c2163db95",
      "displayName": "Unai Egiluz",
      "position": "DEFENDER",
      "type": "REAL",
      "marketValue": 5000000.00,
      "expectedVersion": 0,
      "averagePoints": 5.1,
      "last3AveragePoints": 5.8,
      "realClub": {
        "id": "89fa8cd8-c17a-5756-9387-aca3978e851e",
        "name": "Athletic Club",
        "shortName": "ATH"
      }
    },
    {
      "playerInstanceId": "047b9e88-8354-4873-9fd4-74dc31713726",
      "playerDefinitionId": "a8b259b9-a6d1-56e0-b16a-ff0744a14684",
      "displayName": "Etienne Eto'o",
      "position": "FORWARD",
      "type": "REAL",
      "marketValue": 5000000.00,
      "expectedVersion": 0,
      "averagePoints": 6.3,
      "last3AveragePoints": 7.1,
      "realClub": {
        "id": "bd3ebb2d-2755-5be9-870f-90af12d25b6a",
        "name": "Rayo Vallecano",
        "shortName": "RAY"
      }
    },
    {
      "playerInstanceId": "0803e4bc-98a1-47f0-b622-b4ee48b29bdd",
      "playerDefinitionId": "eb528531-a74e-51f0-86c2-94cd97b21c17",
      "displayName": "Lucas Torró",
      "position": "MIDFIELDER",
      "type": "REAL",
      "marketValue": 5000000.00,
      "expectedVersion": 0,
      "averagePoints": 5.5,
      "last3AveragePoints": 5.2,
      "realClub": {
        "id": "1045d91c-1623-5f00-b3f6-4c4e858166f6",
        "name": "CA Osasuna",
        "shortName": "OSA"
      }
    },
    {
      "playerInstanceId": "2a7b3f1e-4db3-42fd-a1b4-aa1cf2a883ce",
      "playerDefinitionId": "f4f7d250-de56-583d-853f-59abe78bc736",
      "displayName": "Enzo Bardeli",
      "position": "MIDFIELDER",
      "type": "REAL",
      "marketValue": 5000000.00,
      "expectedVersion": 0,
      "averagePoints": 4.9,
      "last3AveragePoints": 5.0,
      "realClub": {
        "id": "2e19e51c-0016-55cc-a523-8d01228f8ee5",
        "name": "Levante UD",
        "shortName": "LEV"
      }
    },
    {
      "playerInstanceId": "627fa419-da2b-42c3-b2b6-9ec5baf140f5",
      "playerDefinitionId": "44cf6665-8882-5888-bc36-faf564fd5ad4",
      "displayName": "Giovani Lo Celso",
      "position": "MIDFIELDER",
      "type": "REAL",
      "marketValue": 5000000.00,
      "expectedVersion": 0,
      "averagePoints": 7.2,
      "last3AveragePoints": 8.0,
      "realClub": {
        "id": "2ecf78f4-13e1-5b6f-a8cf-d54cb0a5f65d",
        "name": "Real Betis Balompié",
        "shortName": "BET"
      }
    },
    {
      "playerInstanceId": "4557f5c7-075a-43ec-8be1-a3ae630868ea",
      "playerDefinitionId": "51c13c9e-2422-5a01-9959-8cec76910bef",
      "displayName": "Carles Aleñá",
      "position": "MIDFIELDER",
      "type": "REAL",
      "marketValue": 5000000.00,
      "expectedVersion": 0,
      "averagePoints": 5.3,
      "last3AveragePoints": 5.6,
      "realClub": {
        "id": "69643b14-a20e-5d7a-a578-9f8f0bef9843",
        "name": "Deportivo Alavés",
        "shortName": "ALA"
      }
    }
  ]
}
